import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import { faBell, faCheck } from '@soundxyz/font-awesome/pro-solid-svg-icons/index.mjs';
import type { ButtonProps } from '@components/main-components/button/Button';
import { Button } from '@components/main-components/button/Button';
import { DataTestId } from '@utils/test';

type AudienceButtonProps = {
  showSubscribed: boolean;
  loading: boolean;
  onClick: ButtonProps['onClick'];
  isOwner: boolean;
};

export const AudienceButton = ({
  showSubscribed,
  loading,
  onClick,
  isOwner,
}: AudienceButtonProps) => {
  //dont show button is artist is the same as the logged in user
  if (isOwner) return null;

  return (
    <Button
      testId={DataTestId.GET_NOTIFIED_BUTTON}
      className={clsx(
        'font-title text-title-xs font-medium focus:border-none focus:outline-none',
        showSubscribed ? '!bg-neutral100 text-black' : 'text-white',
      )}
      variant={showSubscribed ? 'secondary' : 'primary'}
      label={showSubscribed ? 'Subscribed' : 'Get Notified'}
      leadingIcon={<FontAwesomeIcon icon={showSubscribed ? faCheck : faBell} fontSize={20} />}
      loading={loading}
      onClick={onClick}
    />
  );
};
